import { render, staticRenderFns } from "./ButtonTextToggle.vue?vue&type=template&id=6a581591&scoped=true"
import script from "./ButtonTextToggle.vue?vue&type=script&lang=js"
export * from "./ButtonTextToggle.vue?vue&type=script&lang=js"
import style0 from "./ButtonTextToggle.vue?vue&type=style&index=0&id=6a581591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a581591",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
